import ValidationError from "../../../shared/domain/exceptions/ValidationError";
import ValueObject from "../../../shared/domain/ValueObject";
import { RuleAction, RuleActionEnum } from "../RuleAction";
import { RuleTypeEnum } from "../RuleType";
import { RuleValue, TieWinner } from "../RuleValue";

export class WebUrlRuleValue extends ValueObject<WebUrlRuleValuePrimitive> implements RuleValue<RuleTypeEnum.WEB_URL> {
    action: RuleAction;
    matchType: WebUrlMatchType;
    webUrl: URL;

    constructor(value: WebUrlRuleValuePrimitive) {
        super(value);
        this.action = new RuleAction(value.action);
        this.matchType = new WebUrlMatchType(value.matchType);
        try {
            // Sort query params
            let sortedQueryParams: Record<string, string> = {};
            if (value.queryParams && Object.keys(value.queryParams).length > 0) {
                for (const key of Object.keys(value.queryParams).sort()) {
                    sortedQueryParams[key] = value.queryParams[key]!;
                }
            }
            // Save sorted query params
            this.value.queryParams = sortedQueryParams;
            const concatenatedQueryParams = new URLSearchParams(sortedQueryParams).toString();
            this.webUrl = new URL(`https://${value.hostname}${value.path}${concatenatedQueryParams ? `?${concatenatedQueryParams}` : ""}`);
        } catch (e) {
            throw new ValidationError(`Invalid web url: ${value.hostname}${value.path}${value.queryParams ? `?${value.queryParams}` : ""}`);
        }
    }

    getConflictKey(): string {
        return this.webUrl.href;
    }

    conflictsWith(other: this): boolean {
        return (this.webUrl.href === other.webUrl.href);
    }

    resolveTie(other: this): TieWinner {
        if (this.action.isDeny() && other.action.isAllow()) {
            return "other";
        }
        return "self";
    }
}

export type WebUrlRuleValuePrimitive = {
    action: RuleActionEnum;
    matchType: WebUrlMatchTypeEnum;
    hostname: string;
    path: string;
    queryParams: Record<string, string>;
};

export class EnrichedWebUrlRuleValue extends WebUrlRuleValue {
    constructor(value: WebUrlRuleValuePrimitive) {
        super(value);
    }
}

export enum WebUrlMatchTypeEnum {
    EXACT = "EXACT",
    STARTS_WITH = "STARTS_WITH"
}

export class WebUrlMatchType extends ValueObject<WebUrlMatchTypeEnum> {
    constructor(value: WebUrlMatchTypeEnum) {
        super(value);
        this.ensureValid();
    }

    ensureValid(): void {
        if (!Object.values(WebUrlMatchTypeEnum).includes(this.value)) {
            throw new ValidationError(`Invalid web url match type: ${this.value}`);
        }
    }

    isExact(): boolean {
        return this.value === WebUrlMatchTypeEnum.EXACT;
    }

    isStartsWith(): boolean {
        return this.value === WebUrlMatchTypeEnum.STARTS_WITH;
    }
}